import {
  stringValidation,
  nameValidation,
  emailValidation,
  phoneNumberValidation,
  dropdownValidation,
} from './base'
import { validator } from './core'

export const enquiryFormSchema = (countryCode: string) => {
  return validator
    .object()
    .required()
    .shape({
      firstName: nameValidation('First Name'),
      surname: nameValidation('Surname'),
      emailAddress: emailValidation(),
      mobileNumber: phoneNumberValidation('Mobile Number', countryCode),
      enquiryType: dropdownValidation('Enquiry Type'),
      enquiryDetails: stringValidation('Enquiry Details'),
    })
}
